export default [
  {
    path: '/vistoria/:vistoriaId/imovel-ambiente/:ambienteId/item',
    name: 'ImovelItemList',
    component: () => import('./ImovelItensList'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/imovel-ambiente',
      domain: 'itens',
      sidebar: false,
      title: 'Item do ambiente',
      icon: 'keyboard_backspace',
    },
    children: [
      {
        path: '/vistoria/:vistoriaId/imovel-ambiente/:ambienteId/item-new',
        name: 'ImovelItensForm',
        component: () => import('./ItensForm/ImovelItensForm'),
        meta: {
          sidebar: false,
          routerBack: '/vistoria/:vistoriaId/imovel-ambiente/:ambienteId/item',
          domain: 'Itens',
          title: 'Novo item do ambiente',
          icon: 'keyboard_backspace',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/Vistoria/Ambiente/Itens/ImovelItensRouter.js